import React from 'react';
import t from 'react-translate';
import { AlertMessageProps } from 'redux/schemas/app/alert-message';
import { css } from '@emotion/react';
import AlertMessage from './alert-message';

const customAlertStyles = css`
  &.alert-message {
    .flash-message-container, .flash-content-text {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      display: flex;
    }
  }
`;

const AlertMentoringProgramCloningMessage = (
  props: AlertMessageProps & { removeAlertMessage: Function },
) => {
  const { customElement, ...alertProps } = props;
  const { programHref, name } = customElement?.props || {};
  const programName = name || '';

  const AlertMessageExtraElements = () => (programHref ? (
    <a
      target='_blank'
      rel='noopener noreferrer'
      className='open-link d-flex align-items-center text-primary ml-3'
      href={programHref}
      onClick={() => props.removeAlertMessage()}
    >
      <i className='icon icon-open-external' />
      <span className='font-weight-bolder ml-1'>
        {t.MENTORING_PROGRAMS.PROGRAM_HEADER_MENU.CLONE.ALERT.OPEN_PROGRAM()}
      </span>
    </a>
  ) : null);

  const CustomMessage = () => (
    <span>
      {t.MENTORING_PROGRAMS.PROGRAM_HEADER_MENU.CLONE.ALERT.COMPLETED_MESSAGE(programName)}
    </span>
  );

  return (
    <AlertMessage
      {...alertProps}
      extraContent={<AlertMessageExtraElements />}
      customMessage={<CustomMessage />}
      extraStyles={customAlertStyles}
    />
  );
};

export default AlertMentoringProgramCloningMessage;
